<template>
  <div id="app">
    <header :class="$store.state.headerclass">
      <div id="toplogo">
        <router-link to="/">
            <img alt="Lexi's Kitchen Logo" src="./assets/logo.png">
        </router-link>
      </div>
      <div id="menuIcon" >
        <div id="menuIconContainer" v-on:click="$store.commit('openNav')">
          <MenuIcon/>
        </div>
      </div>
    </header>
    <Nav/>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <Footer/>
  </div>
</template>

<script>
import auth from './mixins/auth'
import MenuIcon from 'icons/Menu'

import Footer from '@/components/Footer'
import router from './router'
import Nav from '@/components/Nav'

export default {
  name: 'app',
  components: {
    MenuIcon,
    Footer,
    Nav
  },
  mixins: [auth],
  data() {
    return {
      loggedin: this.$store.state.auth,
      list: {},
      uid: '',
      nav: false
    }
  },
  created() {
    this.checkAuth()
  },
  beforeMount() {
  },
  methods: {
    checkAuth() {
      this.isAuthenticated((user) => {
        if (user === 'not authenticated') {
          return null
        }
        this.logIn()
        if (this.$root.$route.query.redirect) {
          router.push({ path: this.$root.$route.query.redirect })
        } else if (this.$root.$route.path === '/login') {
          router.push({ path: 'kitchen' })
        }
      })
    },
    logIn() {
      this.$store.commit('signIn')
      this.loggedin = true
    },
    logOut() {
      this.username = ''
      this.$store.commit('signOut')
      this.$store.commit('setUserName', '', null)
      this.loggedin = false
      this.$store.commit('closeNav')
      if (this.$root.$route.path === '/kitchen') {
        router.push({path: 'login'})
      }
    }
  }

}
</script>

<style lang="scss">
:root #app {
  /* Colors */
  --lkred: #a72c2c;
  --amazonOrange: #a72c2c;
  --lightAmazonOrange: #C84E4E;
  --darkAmazonOrange: #560000;
  --squidInk: #084E4E;
  --lightSquidInk: #529292;
  --deepSquidInk: #003434;
  --grey: #828282;
  --lightGrey: #C4C4C4;
  --silver: #E1E4EA;
  --darkBlue: #005252;
  --red: #FA2B2B;
  --white: #FFFFFF;
  --light-blue: #529292;
  --inputRed: #FFD8D8;
}
body {
  margin: 0;
}
#app {
  min-height: calc(100vh - 40px);
  width: calc(100vw - 40px);
  padding: 20px;
  font-family: 'Nanum Gothic', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Nanum Myeongjo', 'Open Sans', Helvetica, Arial, sans-serif;
    font-weight: 400;
  }

  input, button {
    max-width: calc(100vw - 50px);
  }

  button {
    background-color: #eaeaea;
    color: var(--squidInk);
  }
  .Form__formSection___3tqxz {
    max-width: 100vw;
  }
  #authenticator {
    div {
      input {
        font-size: 16px!important;
      }
    }
  }
}
header {
  max-width: 760px;
  margin: auto;
  min-height: 57px;
  transition: max-width 0.4s ease;

  &.wide {
    max-width: 1000px!important;
  }

  #toplogo {
    text-align: left;
    float: left;
    max-width: calc(100% - 65px);

    img {
      max-width: 100%;
      width: 300px;

      &.bloglogo {
        width: 200px;
      }
    }
  }
  #menuIconContainer {
    font-size: 30px;
    width: 30px;
    float: right;
    text-align: right;
    margin-top: 10px;
  }
}




.fade-enter-active {
  transition: opacity .5s;
}
.fade-leave-active {
  transition: opacity .3s;
}
.fade-enter {
  opacity: 0;
}
.fade-leave-to {
  opacity: 0;
}

.l-select {
  padding:10px;
  font-size: 16px;
  border-radius: none;
  border: 1px solid #eaeaea;
}
</style>
